import { axiosInstance } from 'boot/axios.js'

export async function answers(ctx, data = {}) {
  try {
    const id = data.id
    delete data.id
    const response = await axiosInstance({
      url: `submissions/${id}/answers`,
      method: 'POST',
      data
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}
